<template>
<div>
    <header>
        <div class="inr">
            <span class="prev">
                <a @click="$router.go(-1)">
                    <img src="@/assets/image/icon-prev.png" alt="뒤로가기">
                </a>
            </span>
            <h1>공지사항</h1>
        </div>
    </header>
    <Footer />
    <main id="sub" class="notice">
        <div class="inr">
            <div class="notice-detail-wrap">
                <div class="notice-detail-tit">
                    <dl>
                        <dt>{{notice.title}}</dt>
                        <dd>{{notice.created}}</dd>
                    </dl>
                </div>
                <div class="notice-detail-content" v-html="notice.content" style="width:100%">
                </div>
            </div>
        </div>
    </main>
</div>
</template>

<script>
import Footer from "@/components/common/Footer";
export default {
    components: {
        Footer
    },
    data() {
        return {
            board_pk: this.$route.params.id,
            notice: {
                title: "",
                content: "",
                created: "",
                attachments: []
            }
        };
    },
    mounted() {
        this.axios.get(`/board/notice/${this.board_pk}`).then(res => {

            if (!res.data.result || res.data.result.is_deleted) {
                alert("삭제되거나 존재하지 않는 게시물입니다.");
                this.$router.push({
                    path: "/notice/list"
                });
                return;
            }

            this.notice.title = res.data.result.title;
            this.notice.content = res.data.result.content;
            this.notice.attachments = JSON.parse(res.data.result.attachments);
            this.notice.created = moment(res.data.result.created).format("YYYY-MM-DD");
        }).catch(err => {
            console.log(err);
        });
    }
};
</script>

<style>
.notice-detail-content img {
    width: 100% !important;
}

.notice-detail-content iframe {
    width: 100% !important;
}

.notice-detail-content table {
    width: 100% !important
}
</style>
